import {Dialog, DialogBody} from '@/components/ui/dialog-atoms/DialogAtoms'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledDialog = styled(Dialog)`
    display: grid;
    grid-template-rows: auto minmax(0, 1fr) auto;
`

export const StyledDialogBody = styled(DialogBody)(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: ${spacing * 4}px;
        & > div:nth-child(-n + 6) {
            grid-column: span 2;
        }
        & > div:nth-child(3),
        & > div:nth-child(6),
        & > div:nth-child(11) {
            grid-column: span 4;
        }
    `
)

export const StyledAgendaEventDetailsLoaderDialogBody = styled(DialogBody)(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        padding: ${spacing * 6}px;
        gap: ${spacing * 4}px;
        width: 100%;
    `
)

export const StyledDot = styled.div(
    ({theme: {spacing, palette}}) => css`
        width: ${spacing * 1.5}px;
        height: ${spacing * 1.5}px;
        border-radius: 50%;
        background-color: ${palette.neutral['black']};
    `
)

export const StyledEventDetailsHeaderTitle = styled(Flexbox)(
    () => css`
        & > button {
            display: inline-flex;
        }
    `
)
